.modal {
  max-width: 28rem;
}

.title {
  color: var(--static-text-strong);

  font-size: var(--fs-normal);
  font-weight: 500;
}

.exportContent {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.exportTitle {
  font-size: var(--fs-small);
  color: var(--static-text-strong);
  font-weight: 500;
}

.exportSubheading {
  font-size: var(--fs-small);
  color: var(--static-text-standard);
}

.buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}